module.exports = __webpack_public_path__ + "static/media/city-elements-facilities-9-svgrepo-com.ddbef0dd.svg";